import { render, staticRenderFns } from "./phproduct.vue?vue&type=template&id=17d9d8e3"
import script from "./phproduct.vue?vue&type=script&lang=js"
export * from "./phproduct.vue?vue&type=script&lang=js"
import style0 from "./phproduct.vue?vue&type=style&index=0&id=17d9d8e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports